import dayjs from "dayjs";
import { SingleDatePicker } from "taltech-styleguide";
import { InputBase } from "./InputBase";

export const InputDateAudit = ({ field, id, ...props }: any) => {
  return (
    <SingleDatePicker
      date={dayjs(field?.value)}
      disabled
      id={id}
      onDateChange={() => {}}
      onFocusChange={() => {}}
      readOnly
      focused={false}
    />
  );
};

export const InputDateModified = () => (
  <InputBase
    id="modifiedDate"
    label="Modified date"
    component={InputDateAudit}
  />
);
export const InputDateCreated = () => (
  <InputDateAudit
    id="createdDate"
    label="Created date"
    component={InputDateAudit}
  />
);
